/**
 * check if two arrays are equal
 */
export const areArraysEqual = (array1: any[], array2: any[]): boolean =>
    array1.length === array2.length && array1.every((v, i) => v === array2[i]);
